import React from "react";
import { Link } from 'react-router-dom';

export const Cta = (klasa="") => {

    return (
        <>
        {/* Tpm Get In touch start */}
        <section className={`get-in-touch-area tmp-section-gapTop mb--100 mb_sm--50 ${klasa.klasa}`}>
            <div className="container">
                <div className="contact-get-in-touch-wrap">
                    <div className="get-in-touch-wrapper tmponhover">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-8">
                                <div className="section-head text-align-left">
                                    <div className="section-sub-title tmp-scroll-trigger tmp-fade-in animation-order-1">
                                        <span className="subtitle">Izrada Web Sajta</span>
                                    </div>
                                    <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">Spremni za sledeći korak? </h2>
                                    <p className="description tmp-scroll-trigger tmp-fade-in animation-order-3">Pređite na stranicu sa cenama i odaberite paket ili nam pošaljite poruku. Tu smo da vam pomognemo i unapredimo vaše poslovanje. Konsultacije su potpuno besplatne.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="cta-contact-inner">
                                    <Link to="/kontakt" className="tmp-btn hover-icon-reverse btn-border btn-md radius-round">
                                        <span className="icon-reverse-wrapper">
                                        <span className="btn-text">Cene paketa</span>
                                        <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                        <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                        </span>
                                    </Link>

                                    <Link to="/kontakt" className="tmp-btn hover-icon-reverse btn-border btn-md radius-round">
                                        <span className="icon-reverse-wrapper">
                                        <span className="btn-text">Kontakt</span>
                                        <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                        <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* Tpm Get In touch End */}
        </>
    )
}